module.exports = __webpack_public_path__ + "static/img/diagnisis.43074eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/diagnisis.png
// module id = m8pl
// module chunks = 3